module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABZklEQVRYR93XTUrDQBQH8P8bQe/gQs9g2k3bkHQpfqwEW4+gN/IOTawudNtaUzcGryCIp2jJkxELQZJMZjLpgNmW9P/jvfl4ITh+yHE+lIDFMj3LGLcMrIjFTegfPdpEKwHzJP1i5n0ZSoQVES6DfndqC6EEzJL0A8yHm0DbCCVgsUyPM8Y9M+/mEUw0GvY7d00roQTIgNlrek4ZJm0gagHaRNQGSMTvjoj+VgKCxmGvE5u0QwvQBkIbIBHPydspg+J8JQCsaYdGupUwAlQhBIlxMPCiuu0wBmwQGVME8F4ucK2DaASQofOX9xNGFhcgroKBN1FVojGgCkEQF6HvPVQhrADKEAR8hn734P8DytbBVlrgdBHKA8nZNiw7DXXOgJ8hR7VPi363FW4EKLoRTe8BbYDT67itqajWGmgrvFYLyoZSW+O5sgLOx3LnHyb5TzMIuh72vCeTs6PsHWULbIYV/ZdzwDcPwxIw9+z39gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow1.png
// module id = spEU
// module chunks = 1